@if (displayFileUploaded) {
  <div class="file_list">
    @if (uploadedFiles.length === 0) {
      <div [style.font-size]="overridedCSS?.inputFontSize">
        @if (isLoaderActive) {
          <p-progressSpinner />
        } @else {
          {{ uploadedFileList_noFiles | translate }}
        }
      </div>
    } @else {
      <table aria-label="uploaded files table" class="uploadedFiles">
        <thead>
          <tr class="file_list_header">
            <th colspan="2" scope="colgroup">
              <span [style.font-size]="overridedCSS?.labelFontSize">{{ uploadedFileList_title | translate }}</span>
            </th>

            <th scope="col">{{ fileList_createdDate | translate }}</th>

            @for (tag of displayedTags | slice: 0 : 4; track $index) {
              <th scope="col">
                {{ tag.colLabel }}
              </th>
            }

            <th scope="col">
              <input
                #filterInput
                class="file_upload_input_search"
                type="text"
                value=""
                width="10vw"
                [id]="inputId()"
                placeholder="{{ uploadedFileList_search | translate }}"
                (keyup)="updateFilterOptions($event, filterInput.value, 'files')" />
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            [ngTemplateOutlet]="tableBody"
            [ngTemplateOutletContext]="{ files: uploadedFiles | filterList: filterListOptions }" />
        </tbody>
      </table>
    }
  </div>

  @if (linkedFiles.length > 0) {
    <div class="file_list linked_file" data-cy="fileupload-linkedfile-list">
      <table aria-label="linked files table" class="linkedFiles">
        <thead>
          <tr class="file_list_header">
            <th colspan="2" scope="colgroup">
              <span [style.font-size]="overridedCSS?.labelFontSize">{{ linkedFileList_title | translate }}</span>
            </th>

            <th scope="col">{{ fileList_createdDate | translate }}</th>

            @for (tag of displayedTags | slice: 0 : 4; track $index) {
              <th scope="col">
                {{ tag.colLabel }}
              </th>
            }

            <th scope="col">
              <input
                #filterLinkedInput
                class="file_upload_input_search"
                type="text"
                value=""
                width="10vw"
                [id]="inputId()"
                placeholder="{{ uploadedFileList_search | translate }}"
                (keyup)="updateFilterOptions($event, filterLinkedInput.value, 'linkedFiles')" />
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            [ngTemplateOutlet]="tableBody"
            [ngTemplateOutletContext]="{ files: linkedFiles | filterList: filterLinkedListOptions }" />
        </tbody>
      </table>
    </div>
  }
}

<iu-prime-overlay
  #op
  appendTo="body"
  baseZIndex="2000"
  styleClass="fileUpload-overlayPanel"
  [showCloseIcon]="true"
  [style]="{ width: '450px' }">
  <ng-template pTemplate>
    <p-table [paginator]="true" [rows]="5" [value]="displayedTags | slice: 4">
      <ng-template pTemplate="header">
        <tr>
          <th scope="col">{{ 'fileupload.tagName' | translate }}</th>
          <th scope="col">{{ 'fileupload.tagValue' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template let-displayedTag let-rowData pTemplate="body">
        <tr [pSelectableRow]="rowData">
          <td>{{ displayedTag.colLabel }}</td>
          <td>
            {{
              (selectedFile.tags['META|' + displayedTag.columnName.toUpperCase() + '$']
                ? selectedFile.tags['META|' + displayedTag.columnName.toUpperCase() + '$']
                : selectedFile.tags['META|' + displayedTag.columnName.toUpperCase()]
              ) | docServerFormatValue: displayedTag.ad_reference_id
            }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</iu-prime-overlay>

@if (isReadOnly || canUpload) {
  <div>
    <h3 class="upload-list-title" style="margin-top: 0px">{{ uploadingFileList_title | translate }}</h3>
    <div [ngClass]="['ui-fileupload', styleClass || '']" [ngStyle]="style">
      <div
        #content
        data-cy="fileupload-click-or-drop-zone"
        [ngClass]="['ui-fileupload-content ui-corner-bottom']"
        (click)="addFile($event)"
        (dragenter)="onDragEnter($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">
        <p-messages [enableService]="false" [value]="msgs" />
        <input
          #advancedfileinput
          data-cy="fileupload-input-file"
          style="display: none"
          type="file"
          [id]="inputId()"
          [multiple]="multiple"
          [readonly]="isReadOnly"
          [tabindex]="isReadOnly ? '-1' : null"
          (blur)="onBlur()"
          (change)="onFileSelect($event)"
          (focus)="!isReadOnly ? onFocus() : null" />
        @if (!hasFiles()) {
          <div class="ui-fileupload-label">
            <i aria-hidden="true" class="fas fa-cloud-upload-alt fa-4x"></i>
            <p>{{ uploadingFileList_drag | translate }}</p>
          </div>
        } @else {
          <div class="ui-fileupload-files">
            <table aria-label="files upload table" class="ui-fileupload-table">
              @for (file of files; track $index; let i = $index) {
                <tr>
                  @if (uploadingFiles.indexOf(file) !== -1) {
                    <td>
                      <p-progressSpinner />
                    </td>
                  }
                  <td>
                    <ng-container
                      [ngTemplateOutlet]="fileLogo"
                      [ngTemplateOutletContext]="{
                        fileItem: file | fileUploadLogoFile: fromDocServer : isImage,
                        i: i,
                      }" />
                  </td>
                  <th scope="row">
                    <div
                      class="prime-fileupload-filename"
                      [ngStyle]="{
                        width: content | getPercentInPxCss: { of: 'clientWidth', many: 40 },
                      }"
                      [style.font-size]="overridedCSS?.inputFontSize">
                      {{ file.name }}
                    </div>
                  </th>
                  <td>
                    <iu-tags-editor-ui [(tags)]="tags[i]" />
                  </td>
                  <td>
                    @if (uploadingFiles.indexOf(file) === -1) {
                      <button icon="fa fa-trash" pButton type="button" (click)="remove($event, i)"></button>
                    }
                  </td>
                </tr>
              }
            </table>
          </div>
        }
      </div>
      <div class="ui-fileupload-url-input">
        <iu-input-text-ui
          #fileuploadUrlInput
          class="ui-fileupload-url-input-text"
          [isStandalone]="true"
          [placeHolder]="'Or attach an url'"
          (enterKey)="attachAnUrl($event, fileuploadUrlInput, fileuploadUrlTags)" />
        <iu-tags-editor-ui #fileuploadUrlTags />
        <iu-button-ui
          [isStandalone]="true"
          [label]="'confirm'"
          (click)="attachAnUrl($event, fileuploadUrlInput, fileuploadUrlTags)" />
      </div>
    </div>
    @if (!auto) {
      <div class="ui-fileupload-button-container">
        @if (displayButtons) {
          <button
            class="p-button p-button-secondary"
            data-cy="fileupload-btn-confirm"
            pButton
            [disabled]="isReadOnly || uploadingFiles.length > 0"
            label="{{ uploadBtn_confirm | translate }}"
            (click)="onClickUploadFiles()"></button>

          <button
            class="p-button p-button-alert"
            data-cy="fileupload-btn-cancel"
            pButton
            [disabled]="isReadOnly || uploadingFiles.length > 0"
            label="{{ uploadBtn_cancel | translate }}"
            (click)="clear()"></button>
        }
      </div>
    }
  </div>
}

<iu-preview-doc [fromDocServer]="fromDocServer" [modal]="true" />

<ng-template #fileLogo let-fileItem="fileItem" let-i="i">
  @if (fileItem && fileItem.isUrl) {
    <img
      alt="file preview"
      class="fileUpload-logo"
      data-cy="previewFile"
      [src]="fileItem.url | docServerUrl | async"
      [width]="previewWidth"
      (click)="onPreview($event, fileItem, i)" />
  } @else if (fileItem) {
    <i
      alt="file preview"
      aria-hidden="true"
      data-cy="previewFile"
      [ngClass]="['fileUpload-icon', fileItem.iconClass ?? '']"></i>
  }
</ng-template>

<ng-template #tableBody let-files="files">
  @for (file of files; track $index; let i = $index) {
    <tr data-cy="fileupload-linkedfile" [attr.data-cy-index]="i">
      <td>
        <ng-container
          [ngTemplateOutlet]="fileLogo"
          [ngTemplateOutletContext]="{ fileItem: file | fileUploadLogoFile: fromDocServer : isImage }" />
      </td>
      <td
        class="fileUpload-name"
        [style.font-size]="overridedCSS?.inputFontSize"
        (click)="file.provider === 'external' ? openLink($event, file.src) : onPreview($event, file, i)">
        {{ file.name }}
      </td>
      <td>
        @if (file.createdDate) {
          <div class="taggedValue">
            <span>{{ file.createdDate }}</span>
          </div>
        }
      </td>

      @for (tag of displayedTags | slice: 0 : 4; track $index) {
        <td class="taggedValue">
          @if (file?.tags?.['META|' + tag.columnName.toUpperCase()]) {
            <div class="taggedValue">
              <span
                [title]="
                  (file.tags['META|' + tag.columnName.toUpperCase() + '$']
                    ? file.tags['META|' + tag.columnName.toUpperCase() + '$']
                    : file.tags['META|' + tag.columnName.toUpperCase()]
                  ) | docServerFormatValue: tag.ad_reference_id
                ">
                {{
                  (file.tags['META|' + tag.columnName.toUpperCase() + '$']
                    ? file.tags['META|' + tag.columnName.toUpperCase() + '$']
                    : file.tags['META|' + tag.columnName.toUpperCase()]
                  ) | docServerFormatValue: tag.ad_reference_id
                }}</span
              >
            </div>
          }
        </td>
      }

      <td>
        @if (file.tags['META|SAE'] === 'Y') {
          @if (file.tags['META|ARKHINEO_ID']) {
            <a
              target="_blank"
              [href]="
                arkhineoBaseUrl +
                '/front/cfe/' +
                arkhineoCfeId +
                '/section/' +
                arkhineoSectionId +
                '/id/' +
                file.tags['META|ARKHINEO_ID']
              ">
              <button class="arkhineo-redirect-btn" pButton type="button" [title]="'arkhineo'">
                <img alt="arkhineo" src="assets/img/cropped-FAVICON-ARKHINEO-270x270.png" />
              </button>
            </a>
          } @else if (file.arkhineoTask) {
            <button
              class="arkhineo-redirect-btn disabled"
              pButton
              type="button"
              [title]="'arkhineo'"
              (click.single)="showTaskMessage(file.arkhineoTask)">
              <img alt="arkhineo" src="assets/img/cropped-FAVICON-ARKHINEO-270x270.png" />
            </button>
          }
        }
        @if (displayedTags?.length > 4) {
          <button
            icon="fas fa-info"
            pButton
            [title]="'fileupload.moreTags' | translate"
            (click)="selectedFile = file; op.toggle($event)"></button>
        }

        @if (file.provider !== 'external') {
          @if (canDownload) {
            <button
              class=""
              icon="fa fa-download"
              pButton
              [title]="'generic.download' | translate"
              (click)="downloadFile($event, file, i)"></button>
          }
          <button
            data-cy="openFileOnSide"
            icon="fa fa-table-columns"
            pButton
            [title]="'generic.openFileOnSide' | translate"
            (click)="openFileOnSide($event, $any(file), i)"></button>
        } @else {
          <button
            data-cy="openInNewTab"
            icon="fas fa-up-right-from-square"
            pButton
            [title]="'generic.openInNewTab' | translate"
            (click)="openLink($event, file.src)"></button>
        }
        <button
          class="fileUpload-copyLink"
          data-cy="copyLinkFile"
          icon="fa fa-link"
          pButton
          [title]="'generic.copyLink' | translate"
          (click)="copyLinkFile($event, file, i)"></button>
        @if (canDelete && (file.isDeletable === undefined || file.isDeletable)) {
          <button
            class="p-button p-button-alert"
            data-cy="deleteFile"
            icon="fa fa-trash"
            pButton
            [title]="'generic.delete' | translate"
            (click)="isReadOnly ? null : deleteFile($event, file, i)"></button>
        }
      </td>
    </tr>
  }
</ng-template>
